// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"965":"9b24f69f","3497":"94ecce99","5592":"7513f45f","6803":"e43918b8","8688":"c979e12a"}[chunkId] + ".chunk.css";
};